function InitVideo() {
    document.querySelectorAll<HTMLElement>('.video').forEach(videoElement => {
        if (videoElement.dataset['bg']) {
            videoElement.style.backgroundImage = videoElement.dataset['bg']
        }
    })

    document.addEventListener('click', (event: MouseEvent) => {
        const videoElement = (event.target as Element).closest<HTMLElement>('.video');
        if (!videoElement) return;

        if (!videoElement.classList.contains('video--is-playing')) {
            videoElement.classList.add('video--is-playing');
            const videoHtml = videoElement.dataset['video'] ?? '';
            videoElement.querySelector('.video__container')?.insertAdjacentHTML('beforeend', videoHtml);
        }
    });
}

InitVideo()
